import React from 'react'
import { Controller } from 'react-hook-form'
import { FormFeedback, Input, InputGroup, InputGroupText, Label } from 'reactstrap'
import {yupResolver} from '@hookform/resolvers/yup'

const InputNumber = ({
  label,
  options,
  control,
  errors,
  type = null,
  disabled = false,
}) => {
  return (
    <React.Fragment>
      <Label className="form-label" for={options.id}>
        {label}
      </Label>
      <Controller
        id={options.id}
        name={options.name}
        control={control}
        render={({ field }) => (
          <InputGroup>
            <Input
              invalid={errors[options.name] && true}
              {...field}
              placeholder=""
              type="tel"
              required={options.required || false}
              disabled={disabled}
              onChange={(e) => {
                e.target.value = e.target.value.replace(/[^0-9]/g, '')
                if (!options.startWithCero &&  e.target.value[0] === '0') return
                if (e.target.value.length <= (options.maxLength || 8)) {
                  field.onChange(e)
                }
              }}
            />
            {
              type === "percent" && <InputGroupText>%</InputGroupText>
            }
          </InputGroup>
        )}
      />
      {errors[options.name] && (
        <FormFeedback>{errors[options.name]?.message}</FormFeedback>
      )}
    </React.Fragment>
  )
}

export default InputNumber
